/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react'

import { SVG } from '@pareto-engineering/design-system'

import PropTypes from 'prop-types'

import styleNames from '@pareto-engineering/bem/exports'

import './styles.scss'

// Local Definitions

const baseClassName = styleNames.base

const componentClassName = 'customers'

/**
 * This is the component description.
 */
const Customers = ({
  id,
  className:userClassName,
  style,
  items,
  heading,
  subtitle,
  sprite,
  wrap,
}) => {
  const hasOddNumberOfItems = items.length % 2 !== 0

  return (
    <div
      id={id}
      className={[
        baseClassName,
        componentClassName,
        userClassName,
      ]
        .filter((e) => e)
        .join(' ')}
      style={style}
    >
      {heading && (
      <div className="header">
        {heading}
      </div>
      )}
      <div className="logos">
        {items.map((item, index) => (
          <SVG
            className={
              [
                'logo x-highlighted',
                wrap && 'wrapped',
                hasOddNumberOfItems && index === items.length - 1 && 'center-self',
              ]
                .filter((e) => e)
                .join(' ')
            }
            sprite={sprite}
            target={item.target}
            viewBox="0 0 512 256"
            width="100%"
          />
        ))}
      </div>
      {subtitle
        && (
        <div className="subtitle">
          {subtitle}
        </div>
        )}
    </div>
  )
}

Customers.propTypes = {
  /**
   * The HTML id for this element
   */
  id:PropTypes.string,

  /**
   * The HTML class names for this element
   */
  className:PropTypes.string,

  /**
   * The React-written, css properties for this element.
   */
  style:PropTypes.objectOf(PropTypes.string),

  /**
   * The array of object with customer logos and an alt text
   */
  items:PropTypes.arrayOf(
    PropTypes.shape({
      altText:PropTypes.string.isRequired,
      image  :PropTypes.string.isRequired,
    }),
  ).isRequired,
  /**
   *  The customers section heading node
   */
  heading :PropTypes.node.isRequired,
  /**
   *  The customers section subtitle node
   */
  subtitle:PropTypes.node,

  /**
   * sprite file
   */
  sprite:PropTypes.string,
}

Customers.defaultProps = {
  sprite:'/customer_logos.sprite.svg',
}

export default Customers
